import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  presensiServive = {}

presensiServive.data = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiServive.show = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiServive.rekap = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/rekap',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiServive.show_all = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/show_all',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiServive.download = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/download',
        method: 'post',
        params: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

presensiServive.multiple_download = function (token,data='') {
    return fetch({
        url: '/transaksi/presensi/multiple_download',
        method: 'post',
        params: data,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}


export default presensiServive;
